import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Shared bottom call-to-action used on inner pages. */
export function CtaBanner({ title = "Ready to talk about your project?" }) {
  return (
    <section className="py-20 bg-steel text-white" data-testid="cta-banner">
      <div className="max-w-4xl mx-auto px-6 text-center space-y-6">
        <span className="font-mono-sub text-xs text-royal-bright uppercase tracking-wider">
          Direct Engagement
        </span>
        <h2 className="font-poster text-3xl font-bold">{title}</h2>
        <p className="text-sm text-slate-400 max-w-xl mx-auto leading-relaxed">
          Tell us what you are building, deploying, or maintaining — one team to
          build, deploy, and support your software.
        </p>
        <Link
          to="/contact"
          data-testid="cta-banner-button"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded bg-royal hover:bg-royal-dark text-white text-sm font-semibold transition-colors"
        >
          Request a Consultation <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
